import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import { IGeneralDentalReferral } from '../../../../models/IGeneralDentalReferral';

interface IGeneralDentalReferralStatus {
    generalDentalReferral: IGeneralDentalReferral;
}

export const GeneralDentalReferralStatus: React.FunctionComponent<IGeneralDentalReferralStatus> = ({ generalDentalReferral }) => {

    return (
        <>
            {
                generalDentalReferral?.generalDentalReferralStatus || generalDentalReferral?.sentDate || generalDentalReferral?.approvedDate || generalDentalReferral?.rejectedDate ?
                    <>
                        <div className="row readonly-less-margin">
                            {
                                generalDentalReferral.sentDate ?
                                    <div className="col-6">
                                        <TextInput name="sentDateReadonly" label="Datum skickad" defaultValue={dateTimeToDateString(generalDentalReferral.sentDate)} inlineLabel readonly />
                                    </div>
                                    : null
                            }
                            {
                                generalDentalReferral.generalDentalReferralStatus && generalDentalReferral.generalDentalReferralStatus != "" ?
                                    <div className="col-6">
                                        <TextInput name="generalDentalReferralStatusReadOnly" label="Status" defaultValue={generalDentalReferral.generalDentalReferralStatus} readonly inlineLabel />
                                    </div>
                                    : null

                            }
                            {
                                generalDentalReferral.approvedDate ?
                                    <div className="col-6">
                                        <TextInput name="approvedDateReadonly" label="Datum godkänd" defaultValue={dateTimeToDateString(generalDentalReferral.approvedDate)} inlineLabel readonly />
                                    </div>
                                    : null
                            }
                            {
                                generalDentalReferral.rejectedDate ?
                                    <div className="col-6">
                                        <TextInput name="rejectedDateReadonly" label="Datum avvisad" defaultValue={dateTimeToDateString(generalDentalReferral.rejectedDate)} inlineLabel readonly />
                                    </div>
                                    : null
                            }
                            {
                                generalDentalReferral.closedDate ?
                                    <div className="col-6">
                                        <TextInput name="closedDateReadonly" label="Datum avslutad" defaultValue={dateTimeToDateString(generalDentalReferral.closedDate)} inlineLabel readonly />
                                    </div>
                                    : null
                            }
                        </div>
                        <hr />
                    </>
                    : null
            }
        </>
    );
}